import { Component, OnDestroy, OnInit } from '@angular/core';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/services/util.service';
import { environment } from 'src/environments/environment';
import { CountryCode, CountryCodes } from 'src/app/constants/countrycodes';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH, PASSWORD_PATTERN } from 'src/app/shared/password-strength/password-requirements';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, OnDestroy  {
  registrationForm: FormGroup;
  isRegistrationError = false;
  registrationMsg: string;
  registrationErrorMsg: string;
  registrationService_: any;
  showSuccessPane: boolean;
  showPassword = false;
  showCPassword = false;
  googleauthuri: SafeResourceUrl;
  countryCodes: Array<CountryCode>;
  postVerificationReturnUrl: string;
  // held so ngOnDestroy can remove the same reference addEventListener was given
  private boundReceiveCredMessage = this.receiveCredMessage.bind(this);

  constructor(private registrationService: UseraccessserviceService, private router: Router, private headerinfo: ComponentheaderService,private util: UtilService,
    private activatedroute: ActivatedRoute, private toaster: ToastrService, private sanitizer: DomSanitizer) {
    this.registrationService_ = registrationService;
    this.googleauthuri = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.ImpataAppDomainUrl}/googleauth`);
    this.registrationForm = new FormGroup({
      fullname: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(PASSWORD_MIN_LENGTH),
        Validators.maxLength(PASSWORD_MAX_LENGTH),
        Validators.pattern(PASSWORD_PATTERN)
      ]),
      cpassword: new FormControl('', [Validators.required, this.passwordMatchValidator()]),
      phone: new FormControl('', [Validators.required, this.phoneNumberValidator()]),
      countrycode: new FormControl('', Validators.required),
    });
    this.countryCodes = CountryCodes
    this.registrationForm.get('countrycode').setValue("+234");
    this.registrationForm.get('password')?.valueChanges.subscribe(() => {
      this.registrationForm.get('cpassword')?.updateValueAndValidity();
    });
  }

  passwordMatchValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      if (!group.value) 
        return null;
     
      const password = this.registrationForm.get('password')?.value;
      const confirm = group.value;
      if (!password || !confirm) return null;
      return password === confirm ? null : { passwordMismatch: true };
    }
  }

  updateLoadScreen(val: boolean) {
    this.registrationService.isLoading = val;
    // reactive-form controls must be disabled through the form API; a [disabled]
    // binding in the template is ignored
    if (val) {
      this.registrationForm.disable();
    } else {
      this.registrationForm.enable();
    }
  }
  
  async OnSubmit() {
    this.updateLoadScreen(true);
    try{
      if(this.registrationForm.valid){
        const timezonename = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const timezone = (new Date().getTimezoneOffset() / 60);
        this.isRegistrationError = false;
        const phone = this.util.reFormatNGorUKPhoneNumber(this.registrationForm.get('phone').value, this.registrationForm.get('countrycode').value);
        const data: any = await this.registrationService.userRegistrationAndSendVerificationMail(this.registrationForm.get('fullname').value, this.registrationForm.get('password').value,
         this.registrationForm.get('email').value, this.registrationForm.get('countrycode').value, phone, timezone, timezonename, this.postVerificationReturnUrl).catch((err) => {
          this.isRegistrationError = true;
          this.registrationErrorMsg = 'An error occured during registration';
        }).finally(() => {
          this.updateLoadScreen(false)
        });
        this.registrationMsg = data  
        this.showSuccessPane = !this.isRegistrationError;
      }
    }
    catch(error){
      console.error(error);
    }
    finally{
      this.updateLoadScreen(false);
    }
  }

  ngOnInit(): void {
    this.headerinfo.setPageTitle('Register');
    this.postVerificationReturnUrl = this.activatedroute.snapshot.queryParams.goto;

    window.addEventListener('message', this.boundReceiveCredMessage, false);
  }

  async receiveCredMessage(event: MessageEvent){
    if (event.origin !== `${environment.ImpataAppDomainUrl}` && event.data.type !== 'GoogleCredentials') {
      return;
    }
    if (event.data.payload){
      try {
        this.registrationService.userGoogleAuthentication(event.data.payload).subscribe(
          (data) => {
            this.navigateAfterGoogleAuth(data['token'], data['email']);
          }
        );
      } catch (error) {
        console.error("Request failed:", error);
      }
    }
  }

  navigateAfterGoogleAuth(token: string, email: string){
    try {
      this.registrationService.updateUserPrivateSchool(email).toPromise();
      // store the token directly instead of handing it to the next page in the query
      // string, where it would persist in history, logs and the Referer header
      this.registrationService.setAuthenticatedUserToken(token);
      window.location.href = '/';
    } catch (error) {
      console.error("Request failed:", error);
    }
  }

  onCountryCodeChange() {
    const phoneControl = this.registrationForm.get('phone');
    if (phoneControl) {
      phoneControl.markAsTouched();
      phoneControl.updateValueAndValidity(); 
    }
  }
  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) 
        return null;
      const number = this.util.reFormatNGorUKPhoneNumber(control.value, this.registrationForm.get('countrycode').value);
      const isValid = this.util.getPhoneNumberRegexPattern(this.registrationForm.get('countrycode').value, number[0]).test(number);
      return isValid ? null : { invalidPhoneNumber: { value: control.value } };
    };
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.boundReceiveCredMessage);
  }
}
